import { produce } from "immer";
import {
  GET_PRE_TEMPLATE,
  GET_PRE_TEMPLATE_SUCCESS,
  GET_PRE_TEMPLATE_FAILURE,
  //
  SAVE_PRE_TEMPLATE,
  SAVE_PRE_TEMPLATE_SUCCESS,
  SAVE_PRE_TEMPLATE_FAILURE,
  //
  GET_ASSESSMENTS,
  GET_ASSESSMENTS_SUCCESS,
  GET_ASSESSMENTS_FAILURE,
  //
  TOGGLE_HISTORY_MODAL,
  //
  GET_PRE_HISTORY,
  GET_PRE_HISTORY_SUCCESS,
  GET_PRE_HISTORY_FAILURE,
  //
  REFRESH_CODE,
  REFRESH_CODE_SUCCESS,
  REFRESH_CODE_FAILURE,
  //
  VERIFY_PIN,
  VERIFY_PIN_SUCCESS,
  VERIFY_PIN_FAILURE,
  //
  UPLOAD_DOC,
  UPLOAD_DOC_SUCCESS,
  UPLOAD_DOC_FAILURE,
  //
  SAVE_ASSESSMENT,
  SAVE_ASSESSMENT_SUCCESS,
  SAVE_ASSESSMENT_FAILURE,
  //
  GET_ASSESSMENT,
  GET_ASSESSMENT_SUCCESS,
  GET_ASSESSMENT_FAILURE,
  //
  UPDATE_PRE_STATUS,
  UPDATE_PRE_STATUS_SUCCESS,
  UPDATE_PRE_STATUS_FAILURE,
  //
  GET_UPLOADED_DOCS,
  GET_UPLOADED_DOCS_SUCCESS,
  GET_UPLOADED_DOCS_FAILURE,
  //
  GET_VIEW_ASSESSMENT,
  GET_VIEW_ASSESSMENT_SUCCESS,
  GET_VIEW_ASSESSMENT_FAILURE,
  //
  REPROCESS_DOC,
  REPROCESS_DOC_SUCCESS,
  REPROCESS_DOC_FAILURE,
} from "./constants";

export const initialState = {
  isFetching: false,
  isSubmitting: false,
  isFetchingAssessments: false,
  preData: {},
  preSections: [],
  assessments: {},
  historyModal: {
    open: false,
    id: null,
  },
  preHistory: {},
  isFetchingPreHistory: false,
  isRefreshingCode: false,
  isVerifyingPin: false,
  isUploadingDoc: false,
  isSavingAssessment: false,
  isFetchingAssessment: false,
  assessment: {},
  uploadedDocs: [],
  isFetchingUploadedDocs: false,
  isFetchingViewAssessment: false,
  viewAssessment: {},
  reprocessingData: {
    loading: false,
    id: null,
  },
};

const ResidentPreAssessReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case GET_PRE_TEMPLATE:
        draft.isFetching = true;
        draft.preData = {};
        draft.preSections = [];
        break;
      case GET_PRE_TEMPLATE_SUCCESS:
        draft.isFetching = false;
        draft.preData = action.payload.preData;
        draft.preSections = action.payload.preSections;
        break;
      case GET_PRE_TEMPLATE_FAILURE:
        draft.isFetching = false;
        draft.preData = {};
        draft.preSections = [];
        break;
      case SAVE_PRE_TEMPLATE:
        draft.isSubmitting = true;
        break;
      case SAVE_PRE_TEMPLATE_SUCCESS:
        draft.isSubmitting = false;
        break;
      case SAVE_PRE_TEMPLATE_FAILURE:
        draft.isSubmitting = false;
        break;
      // GET ASSESSMENTS
      case GET_ASSESSMENTS:
        draft.isFetchingAssessments = true;
        draft.assessments = {};
        break;
      case GET_ASSESSMENTS_SUCCESS:
        draft.isFetchingAssessments = false;
        draft.assessments = action.payload;
        break;
      case GET_ASSESSMENTS_FAILURE:
        draft.isFetchingAssessments = false;
        draft.assessments = {};
        break;
      // TOGGLE HISTORY MODAL
      case TOGGLE_HISTORY_MODAL:
        draft.historyModal = action.payload;
        break;
      // GET PRE HISTORY
      case GET_PRE_HISTORY:
        draft.isFetchingPreHistory = true;
        draft.preHistory = {};
        break;
      case GET_PRE_HISTORY_SUCCESS:
        draft.isFetchingPreHistory = false;
        draft.preHistory = action.payload;
        break;
      case GET_PRE_HISTORY_FAILURE:
        draft.isFetchingPreHistory = false;
        draft.preHistory = {};
        break;
      // REFRESH CODE
      case REFRESH_CODE:
        draft.isRefreshingCode = true;
        break;
      case REFRESH_CODE_SUCCESS:
        draft.isRefreshingCode = false;
        break;
      case REFRESH_CODE_FAILURE:
        draft.isRefreshingCode = false;
        break;
      // VERIFY PIN
      case VERIFY_PIN:
        draft.isVerifyingPin = true;
        break;
      case VERIFY_PIN_SUCCESS:
        draft.isVerifyingPin = false;
        break;
      case VERIFY_PIN_FAILURE:
        draft.isVerifyingPin = false;
        break;
      // UPLOAD DOC
      case UPLOAD_DOC:
        draft.isUploadingDoc = true;
        break;
      case UPLOAD_DOC_SUCCESS:
        draft.isUploadingDoc = false;
        break;
      case UPLOAD_DOC_FAILURE:
        draft.isUploadingDoc = false;
        break;
      // CREATE ASSESSMENT
      case SAVE_ASSESSMENT:
        draft.isSavingAssessment = true;
        break;
      case SAVE_ASSESSMENT_SUCCESS:
        draft.isSavingAssessment = false;
        break;
      case SAVE_ASSESSMENT_FAILURE:
        draft.isSavingAssessment = false;
        break;
      // GET ASSESSMENT
      case GET_ASSESSMENT:
        draft.isFetchingAssessment = true;
        draft.assessment = {};
        break;
      case GET_ASSESSMENT_SUCCESS:
        draft.isFetchingAssessment = false;
        draft.assessment = action.payload;
        break;
      case GET_ASSESSMENT_FAILURE:
        draft.isFetchingAssessment = false;
        draft.assessment = {};
        break;
      // UPDATE PRE STATUS
      case UPDATE_PRE_STATUS:
        draft.isUpdatingPreStatus = true;
        break;
      case UPDATE_PRE_STATUS_SUCCESS:
        draft.isUpdatingPreStatus = false;
        break;
      case UPDATE_PRE_STATUS_FAILURE:
        draft.isUpdatingPreStatus = false;
        break;
      // GET UPLOADED DOCS
      case GET_UPLOADED_DOCS:
        draft.isFetchingUploadedDocs = true;
        draft.uploadedDocs = [];
        break;
      case GET_UPLOADED_DOCS_SUCCESS:
        draft.isFetchingUploadedDocs = false;
        draft.uploadedDocs = action.payload;
        break;
      case GET_UPLOADED_DOCS_FAILURE:
        draft.isFetchingUploadedDocs = false;
        draft.uploadedDocs = [];
        break;
      // GET VIEW ASSESSMENT
      case GET_VIEW_ASSESSMENT:
        draft.isFetchingViewAssessment = true;
        draft.viewAssessment = {};
        break;
      case GET_VIEW_ASSESSMENT_SUCCESS:
        draft.isFetchingViewAssessment = false;
        draft.viewAssessment = action.payload;
        break;
      case GET_VIEW_ASSESSMENT_FAILURE:
        draft.isFetchingViewAssessment = false;
        draft.viewAssessment = {};
        break;
      // REPROCESS DOC
      case REPROCESS_DOC:
        draft.reprocessingData.loading = true;
        draft.reprocessingData.id = action.payload;
        break;
      case REPROCESS_DOC_SUCCESS:
        draft.reprocessingData.loading = false;
        draft.reprocessingData.id = null;
        break;
      case REPROCESS_DOC_FAILURE:
        draft.reprocessingData.loading = false;
        draft.reprocessingData.id = null;
        break;
      default:
        return state;
    }
  });

export default ResidentPreAssessReducer;
